import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './apikey.css';

const ApiKeyManagement = () => {
  const [activeTab, setActiveTab] = useState('All');
  const navigate = useNavigate();

  const [apiKeys, setApiKeys] = useState([
    { id: 1, remark: 'Trading Bot', subRemark: 'For automated trading', key: 'AGCX***a1b2c3d4e5f6', type: 'Spot', permissions: ['Trade', 'Read'], ip: '192.168.1.10', ipCount: '+2 more', created: 'May 27,2024\n10:30 AM', used: 'May 30,2024\n02:15 PM', status: 'Active' },
    { id: 2, remark: 'Portfolio Analyzer', subRemark: 'Portfolio tracking app', key: 'AGCX***a1b2c3d4e5f7', type: 'Margin', permissions: ['Read'], ip: '103.21.244.5', ipCount: '', created: 'May 25, 2024\n09:20 AM', used: 'May 29, 2024\n11:45 AM', status: 'Active' },
    { id: 3, remark: 'Trading Bot 2', subRemark: 'For automated trading', key: 'AGCX***a1b2c3d4e5f8', type: 'Spot', permissions: ['Trade', 'Read'], ip: '192.168.1.10', ipCount: '+2 more', created: 'May 27,2024\n10:30 AM', used: 'May 30,2024\n02:15 PM', status: 'Active' },
    { id: 4, remark: 'Copy Trading', subRemark: 'Copy leading traders', key: 'AGCX***a1b2c3d4e5f9', type: 'Spot', permissions: ['Read'], ip: '103.21.244.5', ipCount: '', created: 'Jan 15, 2024\n09:20 AM', used: 'Jan 29, 2024\n11:45 AM', status: 'Disabled' },
    { id: 5, remark: 'Tax Reporting', subRemark: 'Tax tracking app', key: 'AGCX***a1b2c3d4e5f0', type: 'Margin', permissions: ['Read'], ip: '192.168.1.10', ipCount: '', created: 'Feb 10, 2024\n10:30 AM', used: 'Feb 15, 2024\n02:15 PM', status: 'Expired' },
  ]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filterType, setFilterType] = useState('All');
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this API Key?')) {
      setApiKeys(apiKeys.filter(key => key.id !== id));
    }
  };

  const handleEdit = (id, currentRemark) => {
    const newRemark = window.prompt('Enter new remark:', currentRemark);
    if (newRemark && newRemark.trim() !== '') {
      setApiKeys(apiKeys.map(key => key.id === id ? { ...key, remark: newRemark } : key));
    }
  };

  let filteredKeys = activeTab === 'All'
    ? apiKeys
    : apiKeys.filter(item => item.status === activeTab);
  
  if (searchQuery) {
    filteredKeys = filteredKeys.filter(item => item.remark.toLowerCase().includes(searchQuery.toLowerCase()));
  }

  if (filterType !== 'All') {
    filteredKeys = filteredKeys.filter(item => item.type === filterType);
  }


  return (
    <div className='dashboard_right'>
      <div className="api-key-container">
        {/* Header */}
        <div className="api-key-header">
          <div>
            <h2>API Key Management</h2>
            <p>Create and manage API keys to connect your account with third-party applications and trading bots.</p>
          </div>
          <button className="api-key-create-btn" onClick={() => navigate('/create_api_key')}>+ Create New API Key</button>
        </div>

        {/* Stats Cards */}
        <div className="api-key-stats">
          <div className="api-stat-card">
            <div className="api-stat-icon yellow"><i className="ri-key-2-fill"></i></div>
            <div className="api-stat-info">
              <h3>{apiKeys.length}</h3>
              <p>Total API Keys</p>
            </div>
          </div>
          <div className="api-stat-card">
            <div className="api-stat-icon green"><i className="ri-shield-check-fill"></i></div>
            <div className="api-stat-info">
              <h3>{apiKeys.filter(k => k.status === 'Active').length}</h3>
              <p>Active Keys</p>
            </div>
          </div>
          <div className="api-stat-card">
            <div className="api-stat-icon gray"><i className="ri-pause-circle-fill"></i></div>
            <div className="api-stat-info">
              <h3>{apiKeys.filter(k => k.status === 'Disabled').length}</h3>
              <p>Disabled Keys</p>
            </div>
          </div>
          <div className="api-stat-card">
            <div className="api-stat-icon blue"><i className="ri-calendar-close-fill"></i></div>
            <div className="api-stat-info">
              <h3>{apiKeys.filter(k => k.status === 'Expired').length}</h3>
              <p>Expired Keys</p>
            </div>
          </div>
        </div>

        <div className='apikeytabl_data'>

          {/* Tabs & Search */}
          <div className="api-key-toolbar">
            <div className="api-tabs">
              {[`All (${apiKeys.length})`, `Active (${apiKeys.filter(k => k.status === 'Active').length})`, `Disabled (${apiKeys.filter(k => k.status === 'Disabled').length})`, `Expired (${apiKeys.filter(k => k.status === 'Expired').length})`].map(tab => (
                <div
                  key={tab}
                  className={`api-tab ${activeTab === tab.split(' ')[0] ? 'active' : ''}`}
                  onClick={() => setActiveTab(tab.split(' ')[0])}
                >
                  {tab}
                </div>
              ))}
            </div>
            <div className="api-actions">
              <div className="api-search">
                <i className="ri-search-line"></i>
                <input 
                  type="text" 
                  placeholder="Search by API remark" 
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
              <div className="api-filter-wrapper">
                <button className="api-filter-btn" onClick={() => setShowFilterDropdown(!showFilterDropdown)}>
                  <i className="ri-filter-3-line"></i> Filters {filterType !== 'All' && `(${filterType})`}
                </button>
                {showFilterDropdown && (
                  <ul className="api-select-options api-filter-dropdown">
                    {['All', 'Spot', 'Margin'].map(type => (
                      <li 
                        key={type} 
                        className={filterType === type ? 'selected' : ''}
                        onClick={() => { setFilterType(type); setShowFilterDropdown(false); }}
                      >
                        {type} Type
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="api-table-wrapper">
            <table className="api-table">
              <thead>
                <tr>
                  <th>Api Remark</th>
                  <th>Key</th>
                  <th>Account Type</th>
                  <th>Permissions</th>
                  <th>IP Whitelist</th>
                  <th>Created At</th>
                  <th>Last Used</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredKeys.map((item, i) => (
                  <tr key={i}>
                    <td data-label="Api Remark">
                      <div className="api-remark-col">
                        <div className={`api-remark-icon ${item.remark === 'Trading Bot' ? 'yellow' : 'purple'}`}>
                          {item.remark.substring(0, 1) + item.remark.split(' ')[1].substring(0, 1)}
                        </div>
                        <div>
                          <div className="api-remark-title">{item.remark}</div>
                          <div className="api-remark-sub">{item.subRemark}</div>
                        </div>
                      </div>
                    </td>
                    <td data-label="Key">
                      <div className="api-key-text">
                        {item.key} <i className="ri-file-copy-line"></i>
                      </div>
                    </td>
                    <td data-label="Account Type">
                      <span className={`api-type-badge ${item.type.toLowerCase()}`}>{item.type}</span>
                    </td>
                    <td data-label="Permissions">
                      <div className="api-perm-badges">
                        {item.permissions.map(p => (
                          <span key={p} className="api-perm-badge">{p}</span>
                        ))}
                      </div>
                    </td>
                    <td data-label="IP Whitelist">
                      <div className="api-ip-col">
                        {item.ip}
                        {item.ipCount && <span>{item.ipCount}</span>}
                      </div>
                    </td>
                    <td data-label="Created At">
                      <div className="api-date-col">
                        {item.created.split('\n').map((line, idx) => <div key={idx}>{line}</div>)}
                      </div>
                    </td>
                    <td data-label="Last Used">
                      <div className="api-date-col">
                        {item.used.split('\n').map((line, idx) => <div key={idx}>{line}</div>)}
                      </div>
                    </td>
                    <td data-label="Status">
                      <span className={`api-status-${item.status.toLowerCase()}`}>{item.status}</span>
                    </td>
                    <td data-label="Action">
                      <div className="api-action-btns">
                        <button onClick={() => handleEdit(item.id, item.remark)}><i className="ri-pencil-line"></i></button>
                        <button className="delete" onClick={() => handleDelete(item.id)}><i className="ri-delete-bin-line"></i></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="api-pagination">
            <span>Showing {filteredKeys.length > 0 ? 1 : 0} to {filteredKeys.length} of {filteredKeys.length} results</span>
            <div className="api-page-controls">
              <button disabled><i className="ri-arrow-left-s-line"></i></button>
              <button className="active">1</button>
              <button disabled><i className="ri-arrow-right-s-line"></i></button>
            </div>
          </div>

        </div>

      </div>
    </div>

  );
};

export default ApiKeyManagement;
